import { ELeverOrderNameFront } from '../../../constants/leverOrder';
import { ELevelOrderName } from '../../../repositories/price-estimator/entities/moderation_info/ModerationInfoSchema';

export const mapBackToFrontLeverOrder = {
  [ELevelOrderName.Gold]: ELeverOrderNameFront.Gold,
  [ELevelOrderName.Silver]: ELeverOrderNameFront.Silver,
};
